import { render } from "./DetalheTransferencia.vue?vue&type=template&id=3184cc6a&scoped=true"
import script from "./DetalheTransferencia.vue?vue&type=script&lang=js"
export * from "./DetalheTransferencia.vue?vue&type=script&lang=js"

import "./DetalheTransferencia.vue?vue&type=style&index=0&id=3184cc6a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184cc6a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QSelect,QTable,QBtn,QCardSection,QTd,QRadio});
